var map = {
	"./unload-1-1.png": "6a4e",
	"./unload-1-2.png": "0daf",
	"./unload-1-3.png": "fc97",
	"./unload-2-1.png": "2e01",
	"./unload-2-2.png": "e711",
	"./unload-2-3.png": "f3a1",
	"./unload-3-1.png": "aafc",
	"./unload-3-2.png": "07e0",
	"./unload-3-3.png": "796e",
	"./unload-4-1.png": "8b7b",
	"./unload-4-2.png": "ccd7",
	"./unload-4-3.png": "eee9",
	"./unload-5-1.png": "f430",
	"./unload-5-2.png": "3101",
	"./unload-5-3.png": "b45d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "58ab";